import { get } from 'lodash';

const styles = ({ color, margin, padding, fontSize, typography }) => ({
  deploymentsContainer: {
    backgroundColor: get(color, 'uiBackground'),
    width: '100%',
  },
  fieldContainer: {
    margin: `${get(margin, 'm0')} !important`,
  },
  selectField: {
    padding: '2px 10px !important',
  },
  statusIcon: {
    fontSize: 12,
    paddingLeft : 10,
    paddingRight : 10,
  },
  cellContainer : {
    color: get(color, 'bodyText'),
    '& svg': {
      fontSize: '16px',
      verticalAlign: 'middle',
      paddingLeft : 0,
    },
    minWidth : 200,
  },
  deploymentStatusContainer: {
    minWidth : 200,
    display: 'inline-block',
    '& button': {
      color: `${get(color, 'link')} !important`,
      fontSize: `${get(fontSize, 'bodyText')} !important`,
      fontFamily: `${get(typography, 'bodyText')} !important`,
      border: 'none',
      height : 'auto',
      lineHeight: 0,
    },
  },
  deploymentButtonsContainer: {
    minWidth : 200,
    '& button': {
      margin: get(margin, 'm0'),
      padding: get(padding, 'p0'),
      paddingRight: 30,
      height: 'auto',
      lineHeight: '1 !important',
      fontWeight: '300 !important',
      color: `${get(color, 'link')} !important`,
      fontSize: `${get(fontSize, 'bodyText')} !important`,
      fontFamily: `${get(typography, 'bodyText')} !important`,
      textTransform: 'none',
      textDecoration: 'none',
    },
    '& button:hover': {
      color: `${get(color, 'linkHover')} !important`,
      textTransform: 'none',
      textDecoration: 'none',
    },
    '& button:focus': {
      boxShadow: 'none !important',
      outline: '0px !important',
      textTransform: 'none',
      textDecoration: 'none',
    },
    '& button:only-child': {
      marginLeft : 120,
    },
  },
  listContainer: {
    width: '100%',
    height: '100%',
  },
  filterSection: {
    marginTop: 0,
    paddingTop: 0,
    justifyContent: 'left',
  },
});

export default styles;
